import { Platform } from 'react-native';
import Config from 'react-native-config';
import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { JsonObj } from '@mhp/general-interface';

export const GET_APP_SETTINGS = 'APP_SETTINGS.GET_APP_SETTINGS';
export const GET_APP_SETTINGS_SUCCESS = 'APP_SETTINGS.GET_APP_SETTINGS_SUCCESS';
export const GET_APP_SETTINGS_FAIL = 'APP_SETTINGS.GET_APP_SETTINGS_FAIL';

export const getAppSettings = (): GetAppSettingsAction => ({
  type: GET_APP_SETTINGS,
  payload: {
    client: 'dispatcher',
    request: {
      url: getDispatcherUrl(
        DispatcherCategoryService.APP_SETTINGS,
        DispatcherAuthPrefix.PUBLIC,
        DispatcherResource.APP_SETTINGS,
        `${DispatcherEndpoint.SETTINGS}?platform=${Platform.OS}&version=${Config.APP_VERSION}`
      ),
      headers: {
        [DFDHeaders.mhpAdapter]: AdapterSource.MHP,
        settingskey: Config.APP_SETTINGS_KEY
      }
    }
  }
});

interface GetAppSettingsAction {
  type: typeof GET_APP_SETTINGS;
  payload: JsonObj;
}

interface GetAppSettingsSuccessAction {
  type: typeof GET_APP_SETTINGS_SUCCESS;
  payload: {
    data: JsonObj;
  };
}

interface GetAppSettingsFailAction {
  type: typeof GET_APP_SETTINGS_FAIL;
  error: JsonObj;
}

export type AppSettingsAction =
  | GetAppSettingsAction
  | GetAppSettingsSuccessAction
  | GetAppSettingsFailAction;
